"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-content-modals/data/RequestStatuses/selectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-content-modals/data/RequestStatuses/RequestStatusTypes"));

var _default = function _default(requestType) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(requestType) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.default = _default;
module.exports = exports.default;